// @mui
import { Box } from '@mui/material';
// components
import { Gmap } from '../../../components/map';
// data
import { getMapMarkers } from '../../../data/contact-info';

// ----------------------------------------------------------------------
// Markers come from the shared contact-info file so the pin always matches
// the address card shown above it. Built once at module scope: the set is
// static data, so the identity stays stable and the map never re-fits
// needlessly.
const markers = getMapMarkers();

// ----------------------------------------------------------------------

export default function ConatctMap({ ...other }) {
  return (
    <Box {...other}>
      <Gmap markers={markers} />
    </Box>
  );
}
